//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
	name: "ResultViewToggle",
	props: {},
	computed: {
		...mapGetters(["resultView"]),
		view: {
			get() {
				return this.resultView;
			},
			set(val) {
				this.setStateValue(["resultView", val])
			}
		},
	},
	methods: {
		...mapMutations(["setStateValue"]),
	},
	// created() {},
}
